import { Button, DatePicker, Form, Input,  Table } from "antd"
import { searchUpgrade } from "../../api"
import {  PageBuilder } from "../../utils/Page"
import { useEffect, useState } from "react"
import '../matchResult/index.css'
import { UpgradeSearchFilter, UpgradeView } from "../../interfaces/Upgrade"
import { format } from 'date-fns';

const Upgrade = () => {
    const [searchFilter, setSearchFilter] = useState<UpgradeSearchFilter>({})
    const [data, setData] = useState<UpgradeView[]>()
    const [current, setCurrent] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [totalElements, setTotalElements] = useState<number>(500)
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
        },
        {
            title: "用户编号",
            dataIndex: "userNumber",
        },
        {
            title: "申请时间",
            dataIndex: "applicationTime",
           render: (time?: Date) => time?format(time, 'yyyy-MM-dd'):''
        },
        {
            title: "原金额",
            dataIndex: "originAmount",
        },
        {
            title: "当前金额",
            dataIndex: "currentAmount",
        },
    ]

    const search = async () => {
        const page = new PageBuilder()
            .setPage(current - 1)
            .setSize(pageSize)
            .build()
        const { data } = await searchUpgrade({
            params: { ...page, searchFilterCombineOperation: "AND" },
            filters: searchFilter
        })
        setData(data.content)
        setTotalElements(data.totalElements)
    }

    const handleSearch = async (filter: UpgradeSearchFilter) => {
        setSearchFilter(filter)
    }

    const handleTableChange = (pagination: any) => {
        setCurrent(pagination.current)
        setPageSize(pagination.pageSize)
    }

    useEffect(() => { search() }, [current, pageSize, searchFilter])
    return <div>
        <div className="flex-box">
            <Form<UpgradeSearchFilter>
                layout="inline"
                onFinish={handleSearch}
            >
                <Form.Item 
                label="手机号: "
                name="phoneNumberLike">
                    <Input />
                </Form.Item>
                <Form.Item
                    label="原金额: "
                    name="originAmount"
                    >
                    <Input type="number"/>
                </Form.Item>
                <Form.Item
                    label="当前金额: "
                    name="currentAmount"
                    >
                    <Input type="number"/>
                </Form.Item>
              <Form.Item
                label="申请开始时间: "
                name="applicationTimeAfter">
                <DatePicker />
              </Form.Item>
                <Form.Item
                    label="申请结束时间: "
                    name="applicationTimeBefore"
                    >
                <DatePicker />
                </Form.Item>
                <div className="search-button">
                <Form.Item>
                    <Button htmlType="reset" type="default">重置</Button>
                </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" type="primary">搜索</Button>
                </Form.Item>
                </div>
            </Form>
        </div>

        <Table<UpgradeView> rowKey={'id'} columns={columns} dataSource={data}
            pagination={{
                current: current,
                total: totalElements,
                hideOnSinglePage: true
            }}
            onChange={handleTableChange}
        />
    </div>
}

export default Upgrade
